<template>
    <span v-if="value">{{ value}} </span>
    <span v-else><i>[empty]</i></span>
</template>

<script>
    export default {
        props: [
            'value'
        ],
        data() {
            return {
            };
        },
    }
</script>

<style>
</style>